module.exports = {
	message: {
		hello_world: 'Hello World'
	},
	down: {
		grid_bot: 'A Crypto Grid Trading Bot',
		overcome_emotional: 'Overcome emotional investing',
		fortune_market: 'Make a fortune in both bull and bear markets',
		contact_email: 'Contact us',
		copy_success: 'Success',
		copy_failed: 'Copy failed',
		press_copy: 'Long press to copy',
		overseas: 'Need US/HK ',
		register_guide: 'Guidelines for Registering US ID',
		recommend: 'recommend',
		enterprise: 'enterprise',
		anytime: 'Anytime',
		trade: 'Trade',
		stay_tuned: 'Stay tuned',
	},
	sign: {
		register_id: 'Register',
		mobile_regist: 'Phone',
		email_regist: 'Email',
		input_phone: 'Please enter your phone number',
		input_email: 'Please enter your email adress',
		set_password: 'Please set the password',
		password_rule: '8-16 digit number and letter combination',
		password_warn: 'Both numbers and letters, between 8-16',
		invite_code: 'Referrer Code',
		agree: 'I have read and agree to the ',
		user_agr: 'User Agreement',
		privacy_agr: 'the Privacy Agreement',
		and: ' and ',
		regist: 'Register',
		agree_warn: 'Please read and agree to the terms first',
		already_regist: 'Registered? Click to download',
		phone_warn: 'Wrong phone number, please fill in again',
		email_warn: 'Wrong email, please fill in again',
		input_code: 'Enter code',
		code_sended: 'Verification code sent to：',
		re_get: ' later will resend',
		regist_success: 'Congratulations on your registration!',
		down_app: 'Download App',
		user_exists: 'User already exists',
		resend: 'Resend',
		wrong_code: 'Wrong verification code',
		choose_area: 'Select Country/Region',
		search: 'Search',
		mobile_xp: 'Phone Number',
		email_xp: 'Email address',
		code_xp: 'Verification Code',
		get_code_xp: 'Send',
		get_code2_xp: 'later, Resend Code',
		set_pwd: 'Set password',
		regist_text: 'Register means read and agree',
		trade: 'Mobile trading anytime, anywhere',
		down: 'Download',
		currently_regist: 'currently regist',
		agreement: 'TERMS AND CONDITIONS',
		no_cn: 'Does not support registration for users from mainland China'
	},
	common: {
		jgz: 'J Golden Zone',
		jgz_down: 'Download',
		invite_regist: 'Invite friend to register',
		open_in_browser: 'Open in Browser',
		jgz_team: 'JGZ Team',
		refresh: 'Click to Reload',
		xp_team: 'XP Team',
		load: 'Loading~',
		xp_network: 'Network timed out, please try again later.',
	},
	invite: {
		scan_down: 'Scan to download',
		invite_code: 'Referrer Code',
		invite: 'Invite Now',
		not_apple: 'This activity is not related to Apple',
		invite_friend: 'Invite friends',
		get_bot: 'Get trading bots now',
		invite_xp: 'Referral Get trading bots now',
		scan_down_xp: 'Scan to download',
		invite_code_xp: 'Referral Links',
		invite_text_xp: 'You can also invite via the following methods',
		invite_code2_xp: 'Copy invitation code',
		invite_url_xp: 'Copy Link',
		invite_hb_xp: 'Generate Poster',
		invite_back: 'return',
		invite_save: 'Save image',
	},
	activity: {
		jgz_activity: 'JGZ Activity',
		failed: 'Oops！Failed to get data。',
		course: 'Course',
		service: 'please contact our',
		consult: 'customer support team via the in-app live chat function.',
		service_text: 'In accordance with Binance’s compliance policies, accounts that have not completed KYC verification by June 1, 2024, will be subject to suspension. Please take necessary actions accordingly. For any inquiries',
		service_h2: 'Dear Users',
		service_title: 'Announcement on Account Suspension for Incomplete KYC',
	},
	alarm: {
		how: 'How to add alert?',
		way: 'When you logged in,open any trading pair K-line page and click the Alert button to add a price alert.'
	},
	activityXP: {
		title: 'New User Bonus',
		h1: 'Crypto Exchange',
		h2: 'Sign Up Bonus',
		activityTime: 'Event Period: 2025/06/06 - 2025/08/31',
		activityRule: 'Participation Rules',
		activityRuleDetail: 'During the event, users who register, complete KYC verification, and accumulate ≥$100 in trading volume will automatically share a $300,000 prize pool.',
		exchangeRule: 'Redemption Rules',
		exchangeRuleDetail: 'Your bonus is proportional to your individual trading volume versus total exchange volume during the event.',
		exchangeType: 'How to Redeem Prizes',
		exchangeTypeDetail: "The bonus will be automatically distributed to user's account between 01/09/2025 and 07/09/2025.",
	}
}